/**
 * Formats a number to a compact string representation for large numbers.
 *
 * @param count - The number to format. Can be a number, undefined, or null.
 * @returns The formatted string in compact notation (e.g., "1.2K") for numbers >= 1000,
 *          the string representation for numbers < 1000, or null if the input is invalid.
 *          Invalid inputs are: null, undefined, non-finite numbers, or negative numbers.
 */
export function formatNumber(count: number | undefined | null): string | null {
    if (count == null || !Number.isFinite(count) || count < 0) {
        return null;
    }

    if (count < 1000) {
        return count.toString();
    }

    return new Intl.NumberFormat('en-US', {
        notation: 'compact',
        compactDisplay: 'short',
        maximumFractionDigits: 1,
    }).format(count);
}
